export default __webpack_public_path__ + "images/VV.ce0f985.png";